import React, { useContext, useState, useEffect } from 'react'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import { useFormik } from 'formik'
import Loaders from '@/product/components/molecules/Loaders'
import SettingContext from '@/product/context/setting/settingContext'
import CustomTable from '@/product/components/molecules/CustomTable'
import { TrainRounded } from '@mui/icons-material'

const TaxTableHistory = (props) => {
    const settingcontext = useContext(SettingContext)

    const { searchTableFetch, search_fetch_data } = settingcontext

    const [isLoading, setIsLoading] = useState(true)

    const data = props.data
    const toggleFullScreenPopup = props.function

    const [tableBody, setTableBody] = useState([])
    const [tableAllBody, setTableAllBody] = useState({
        records: [],
        totalRecords: 0,
        setDisp: '',
    })

    const resetTableandAllBody = () => {
        setTableBody([])
        setTableAllBody({
            records: [],
            totalRecords: 0,
            setDisp: '',
        })
    }

    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: 'desc',
            orderby: 'dcl.id',
            primaryTable: 'data_county_logs',
            tableJoins: [
                {
                    baseTable: 'employees',
                    joinType: 'left',
                    baseJoinField: 'id',
                    connectJoinField: 'user_id',
                },
            ],
            filters: {
                name: {
                    value: '',
                    type: 'in',
                    field: 'dcl.data_county_id',
                },
            },
        },
        onSubmit: (values) => {
            setIsLoading(true)
            searchTableFetch(values, 'data_county_logs')
        },
    })

    useEffect(() => {
        if (data.status === 'history') {
            resetTableandAllBody()
            setIsLoading(true)
            formik.values.filters.name.value = data.id
            formik.values.page = 1
            searchTableFetch(formik.values, 'data_county_logs')
        }
        return () => {
            resetTableandAllBody()
        }
    }, [data.id])

    useEffect(() => {
        return () => setIsLoading(false)
    }, [])

    useEffect(() => {
        if (
            search_fetch_data &&
            search_fetch_data.from === 'data_county_logs'
        ) {
            setTableBody(
                search_fetch_data.records.length
                    ? search_fetch_data.records
                    : []
            )
            setTableAllBody(search_fetch_data)
        }
        setIsLoading(false)
    }, [search_fetch_data])

    const tableValues = []

    tableValues.push(
        {
            field: 'id',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'ID',
            sortField: 'dcl.id',
            filterable: true,
            filterField: 'dcl.id',
        },
        {
            field: 'previous_state_tax',
            type: 'decimal_percentage_three',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'State Tax (%)',
            sortField: 'dcl.previous_state_tax',
            filterable: true,
            filterField: 'dcl.previous_state_tax',
        },
        {
            field: 'previous_city_tax',
            type: 'decimal_percentage_three',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'City Tax (%)',
            sortField: 'dcl.previous_city_tax',
            filterable: true,
            filterField: 'dcl.previous_city_tax',
        },
        {
            field: 'previous_county_tax',
            type: 'decimal_percentage_three',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'County Tax (%)',
            sortField: 'dcl.previous_county_tax',
            filterable: true,
            filterField: 'dcl.previous_county_tax',
        },
        {
            field: 'previous_transit_tax',
            type: 'decimal_percentage_three',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Transit Tax (%)',
            sortField: 'dcl.previous_transit_tax',
            filterable: true,
            filterField: 'dcl.previous_transit_tax',
        },
        {
            field: 'previous_additional_tax_label',
            type: 'text',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Additional Tax Label',
            sortField: 'dcl.previous_additional_tax_label',
            filterable: true,
            filterField: 'dcl.previous_additional_tax_label',
        },
        {
            field: 'notes',
            type: 'text',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Document Number',
            sortField: 'dcl.notes',
            filterable: true,
            filterField: 'dcl.notes',
        },
        {
            field: 'as_employees_emp_firstname,as_employees_emp_lastname',
            type: 'text',
            firstChild: false,
            sort: TrainRounded,
            disablePadding: false,
            label: 'Updated By',
        },
        {
            field: 'created_at',
            type: 'datetime',
            firstChild: false,
            sort: true,
            sortField: 'dcl.created_at',
            disablePadding: false,
            label: 'Updated At',
            filterable: true,
            filterField: 'dcl.created_at',
        }
    )

    return (
        <>
            <FullScreenPopup
                modaltitle={'History'}
                open={data.status === 'history' ? data.popup : false}
                handleClose={() => toggleFullScreenPopup(false)}
                className="staticPagesModal"
            >
                <div className="staticPagesInner customContainer">
                    <div className="">
                        <div className="miscActions d-flex justify-content-start align-items-center flex-wrap mt-4 mb-4"></div>
                        {isLoading ? (
                            <Loaders name="table" isLoading={isLoading} />
                        ) : (
                            <CustomTable
                                formik={formik.values}
                                columnStorageVariable={
                                    'table_settings_tax_table_history'
                                }
                                // columnVisibilityModel={{}}
                                tableBody={tableBody}
                                tableValues={tableValues}
                                tableActions={[]}
                                allData={tableAllBody}
                                changeTableFunction={searchTableFetch}
                                fromVariable="data_county_logs"
                            />
                        )}
                    </div>
                </div>
            </FullScreenPopup>
        </>
    )
}

export default TaxTableHistory
